import React from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import PromoteToWorkspaceModal from './PromoteToWorkspaceModal';

const ModalAppContainer = () => {
  return <PromoteToWorkspaceModal />;
};

export default view(ModalAppContainer);
